export default __webpack_public_path__ + "static/media/chrome_store.5fe250d2.png";